export enum ListColumns {
    LIST_ID = "listId",
    NAME = "name",
    SOURCE_URL = "sourceUrl",
    SIC_CODE = "sicCode",
    NAICS_PRIMARY = "naicsPrimary",
    NAICS_SECONDARY = "naicsSecondary",
    CATEGORY = "category",
    LAST_UPDATED = "lastUpdated",
    PARENT_LIST_ID = "parentListId",
    PARENT_LIST_NAME = "parentListName",
    HEADERS = "headers",
    COUNTRY_CODE = "countryCodes",
    COUNTRY_NAME = "countryNames",
    RECORDS = "records",
}

export enum ListCategory {
    CATEGORY_CLOSED = "closed",
}
